import Button, { type ButtonProps } from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { CircularProgressWithLabel } from '../progressbars';
import { areYouOkContainerSize } from './constants';
import { type StatusIconKey, useIcons } from './utils/useIcon';

export interface AreYouOkButtonProps extends Omit<ButtonProps, 'onClick'> {
  status: StatusIconKey;
  text?: string;
  delay?: number;
  count?: number;
  onClick?: () => void;
}

export const AreYouOkButton = ({
  text,
  status,
  delay = 0,
  count = 0,
  onClick,
  ...rest
}: AreYouOkButtonProps) => {
  const theme = useTheme();
  const {
    icon,
    textColor,
    defaultText,
    timerColor = 'inherit',
  } = useIcons(status);

  const label = text || defaultText;
  const isRunning = count > 0;

  return (
    <Button
      aria-label={label}
      disableRipple
      sx={{ color: `${textColor}!important` }}
      onClick={onClick}
      disabled={isRunning}
      {...rest}
    >
      <Stack
        sx={{
          alignItems: 'center',
        }}
      >
        {isRunning ? (
          <CircularProgressWithLabel
            value={100 - (100 / delay) * count}
            label={`${count}`}
            progressColor={timerColor}
            labelSize={theme.typography.h3.fontSize}
            size={areYouOkContainerSize}
          />
        ) : (
          icon
        )}
        <Typography
          variant="body2"
          sx={{ textTransform: 'capitalize', color: textColor }}
        >
          {label}
        </Typography>
      </Stack>
    </Button>
  );
};
